
<template>
    <section class="with-us"  v-if="loaded && ready"  v-on:mouseover="res" >


      <div class="container block1"  v-if="!isMobile" :class="{'vis' :  offSet.last >= offsetIndex}"  >


        <div class="block1-textbox">
          <h1 class="block1-headline" v-html="cultureData.wrkusHeadline[lang].name" > </h1>
          <div class="block1-text" ><p v-html="cultureData.wrkusText[lang].name"></p> </div>
        </div>


        <div class="block1-media" >
          <media-type :className="'block1-media-type'" :obj="cultureData.media2"  :dynAlt="cultureData.wrkusHeadline[lang].name"></media-type>

        </div>
      </div>

      <div class="container  block1-mob"  v-if="isMobile" :class="{'vis' :  offSet.last >= offsetIndex}" >

        <div class="block1-media">
          <media-type :className="'block1-media-type'" :obj="cultureData.media2"  :dynAlt="cultureData.wrkusHeadline[lang].name"></media-type>

        </div>
        <h1 class="block1-headline" v-html="cultureData.wrkusHeadline[lang].name" > </h1>
        <div class="block1-text" ><p v-html="cultureData.wrkusText[lang].name"></p> </div>




      </div>


      <div class="with-us-content"  >
      <div class="container"  >

        <div class="item-with" v-for="(item, index) in cultureData.carousel" :class="{'vis' :  offSet2.last2 >= index}" >
           <h1 v-html="item.title[lang].name"></h1>
          <p v-html="item.text[lang].name"></p>

        </div>


      </div>






      </div>

<!--
      <div class="container block2" :class="{'vis' :  offSet.last >= 2}"  >




        <div class="vector-anim">

          <div class="vector-anim-box">
            <div class="vector-anim-sprite"  :style="{ 'transform': 'translate3d(0,' + frameVector + 'px ,0)' }">
              <img v-for="i in 300" :src="'/static/images/sequence/imgs-seq/' + i + '.png'" alt="" >
            </div>

          </div>

        </div>


        <carousel :per-page="1"  :paginationEnabled="false" ref="carousel"  class="carousel"  @pageChange="onPageChange" >
          <slide class="slide" v-for="(item, index) in cultureData.carousel" >
            <h3 class="slide-title" v-html="item.title[lang].name"></h3>
            <p class="slide-text" v-html="item.text[lang].name"></p>

          </slide>

        </carousel>

        <div class="carousel-controls">
          <div class="arrow-btn prev-btn" :class="{'disabled' : actPage === 0}" v-on:click="prevPage" ></div>
          <div class="arrow-btn next-btn" :class="{'disabled' : actPage === 10}"  v-on:click="nextPage"></div>
        </div>

      </div>
-->



    </section>
</template>

<script>




    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../../main';
    import MediaType from "./MediaType";




   // import Masonry from "masonry-layout/masonry";



    export default {


        name: 'with-us',
      components: { MediaType},
      props: [ 'offSet', 'lang', 'cultureData', 'isMobile', 'offsetIndex'],
        data() {
            return {
              loaded: false,
              ready: false,
              teamData: [],

              el :{},
              vis: false,
              actPage: 0,
              totalPages: this.cultureData.carousel.length,
              frameVector: 0,
              framesStops: [1, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300],
              actFrame: 1,
              interFrames : 0,
              offSet2: {
                vis: [],
                tops: [],
                last2: -1
              },

            }
        },

      created() {
        const _this = this;


        //alert(this.$route.path.substring(9, this.$route.path.length))


      },
      mounted() {
        const _this = this;
        _this.loaded = true;
        _this.ready = true;
        _this.init();





       // $('#siteloader').load('../../../static/images/sequence.html');




      },

      destroyed() {

      },

      methods: {


          res(){
           // EVENTBUS.$emit('resetTeam');
          },





        init() {
          const _this = this;

          if(this.loaded && this.ready){


            setTimeout(function() {
              _this.initScroll();

            }, 200);

          }
        },

        onPageChange(n){





          const _this = this;



          _this.actPage = n;

          clearInterval(_this.interFrames);
          _this.evtFrame();







        },

        evtFrame(){
          const _this = this;


          _this.interFrames = setInterval(function(){

            if(_this.actFrame < _this.framesStops[_this.actPage]){
              _this.actFrame ++;
            }

           else if(_this.actFrame > _this.framesStops[_this.actPage]){
              _this.actFrame --;
            }

            else if(_this.actFrame === _this.framesStops[_this.actPage]){
              clearInterval(_this.interFrames);
            }

            _this.frameVector = 500  - (500 * _this.actFrame);

            console.log(_this.actFrame)


          }, 15);



        },


        nextPage(){

          if(this.actPage < this.totalPages){
            this.$refs.carousel.goToPage(this.actPage + 1);
          }

        },

        prevPage(){

          if(this.actPage > 0){
            this.$refs.carousel.goToPage(this.actPage - 1);
          }

        },


        initScroll(){
          const _this = this;


          setTimeout(() =>{



            $( window ).scroll(function(e) {

              _this.scrollEvt()
            });

            $( window ).resize(function() {
              _this.reseizeMe();
            });

            _this.reseizeMe();
            _this.scrollEvt();

          }, 100)




        },

        reseizeMe() {

          this.scrollEvt()
        },


        scrollEvt() {

          const _this = this;

          _this.offSet2.act =  $( window ).scrollTop() +  $( window ).height();


          // EVENTBUS.$emit('resetTeam' );
          _this.offSet2.tops = [];
          $('.item-with').each(function(i){

            //  _this.offSet.tops[i].top = $(this).offset().top;

            _this.offSet2.tops.push($(this).offset().top);

            if(_this.offSet2.act > (_this.offSet2.tops[i]  + 200 )&&  !_this.offSet2.vis[i]) {

              _this.offSet2.last2 = i;
              _this.offSet2.vis[i] = true;


            }


            // console.log(  _this.offSet2.tops)
          //  console.log( _this.offSet2.last2)

          });
        },



      },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/WithUs.vue